export default "__VITE_ASSET__c63be80b__"